import * as Accordion from "@radix-ui/react-accordion";
import type { ReactNode } from "react";
import styles from "./animated-accordion.module.css";

export type AnimatedAccordionItem = {
	id?: string;
	title: ReactNode;
	content: ReactNode;
};

type AnimatedAccordionClassNames = {
	root?: string;
	item?: string;
	header?: string;
	trigger?: string;
	icon?: string;
	content?: string;
	contentInner?: string;
};

type AnimatedAccordionProps = {
	items: AnimatedAccordionItem[];
	classNames?: AnimatedAccordionClassNames;
};

function className(...values: Array<string | undefined>) {
	return values.filter(Boolean).join(" ");
}

export function AnimatedAccordion({
	items,
	classNames,
}: AnimatedAccordionProps) {
	return (
		<Accordion.Root
			type="single"
			collapsible
			className={className(styles.root, classNames?.root)}
		>
			{items.map((item, index) => (
				<Accordion.Item
					value={item.id ?? `item-${index}`}
					key={item.id ?? index}
					className={className(styles.item, classNames?.item)}
				>
					<Accordion.Header
						className={className(styles.header, classNames?.header)}
					>
						<Accordion.Trigger
							className={className(styles.trigger, classNames?.trigger)}
						>
							<span>{item.title}</span>
							<span
								className={className(styles.icon, classNames?.icon)}
								aria-hidden="true"
							>
								+
							</span>
						</Accordion.Trigger>
					</Accordion.Header>
					<Accordion.Content
						forceMount
						className={className(styles.content, classNames?.content)}
					>
						<div
							className={className(
								styles.contentInner,
								classNames?.contentInner,
							)}
						>
							{item.content}
						</div>
					</Accordion.Content>
				</Accordion.Item>
			))}
		</Accordion.Root>
	);
}
